import React, { useEffect, useState } from 'react'
import ItemsApp, { ISingleItemStatusItem } from '../features/items/ItemsApp'

interface IProps {
    type: string,
    customLabel?: string
}

export default function StatusChip(props: IProps) {

    const { type, customLabel } = props

    // const itemsApp = new ItemsApp()

    // const label: string = itemsApp.returnStatusLabel(type)

    /**
     * Status
     */
    const statusList: Array<ISingleItemStatusItem> = [
        {
            type: "on-going",
            label: "On-going"
        },
        {
            type: "resolved",
            label: "Resolved"
        },
        {
            type: "available",
            label: "Available"
        },
        {
            type: "in-use",
            label: "Use"
        },
        {
            type: "missing",
            label: "Missing"
        },
        {
            type: "damaged",
            label: "Damaged"
        },
        {
            type: "taken",
            label: "Use"
        },
        {
            type: "returned",
            label: "Return"
        },
        {
            type: "transferred",
            label: "Transfer"
        },
        {
            type: "to-warehouse",
            label: "Warehouse"
        },
        {
            type: "to-section",
            label: "Section"
        },
        {
            type: "to-location",
            label: "Location"
        },
        {
            type: "admin",
            label: "Admin"
        },
        {
            type: "staff",
            label: "Staff"
        },
        {
            type: "superuser",
            label: "Admin"
        },
        {
            type: "guest",
            label: "Guest"
        },
        {
            type: "active",
            label: "Active"
        },
        {
            type: "not-active",
            label: "Not-Active"
        },
        {
            type: "blocked",
            label: "Blocked"
        },
        {
            type: "banned",
            label: "Banned"
        },
        {
            type: "with-user",
            label: "With User"
        },
        {
            type: "restricted",
            label: "Restricted Information"
        },
        {
            type: "not-started",
            label: "Not-Started"
        },
        {
            type: "progress",
            label: "In Progress"
        },
        {
            type: "falied",
            label: "Failed"
        },
        {
            type: "success",
            label: "Success"
        },
        {
            type: "failed",
            label: "Failed"
        },
        {
            type: "new-item",
            label: "New Stock"
        },
        {
            type: "reduce-stock",
            label: "Reduce Stock"
        },
        {
            type: "stock-adjustment",
            label: "Stock Adjustment"
        },
        {
            type: "container",
            label: "Container"
        },
        {
            type: "regular",
            label: "Standalone"
        },
        {
            type: "pending",
            label: "Pending"
        },
        {
            type: "approved",
            label: "Approved"
        },
        {
            type: "fulfilled",
            label: "Fulfilled"
        },
        {
            type: "closed",
            label: "Closed"
        },
        {
            type: "rejected",
            label: "Rejected"
        },
        {
            type: "use",
            label: "Temporary Use"
        },
        {
            type: "move",
            label: "Permanent Transfer"
        },
        {
            type: "preparing",
            label: "Preparing"
        },
        {
            type: "ready",
            label: "Ready For Transit"
        },
        {
            type: "transit",
            label: "In Transit"
        },
        {
            type: "project",
            label: "Use for Project"
        },
        {
            type: "office",
            label: "Use in Office"
        },
        {
            type: "personal",
            label: "Personal Use"
        },
        {
            type: "testing",
            label: "Testing Purpose"
        },
        {
            type: "relocate",
            label: "Relocate Permanently"
        },
        {
            type: "unavailable",
            label: "Unavailable"
        },
        {
            type: "reserved",
            label: "Reserved"
        },
        {
            type: "returning",
            label: "Returning"
        },
        {
            type: "returned",
            label: "Returned"
        },
        {
            type: "received",
            label: "Received"
        },
        {
            type: "create",
            label: "Created"
        },
        {
            type: "good",
            label: "Good"
        },
        {
            type: "deleted",
            label: "Deleted"
        },
        {
            type: "offline",
            label: "Offline"
        },
        {
            type: "disabled",
            label: "Disabled"
        },
        {
            type: "online",
            label: "Online"
        },
        {
            type: "printing",
            label: "Printing"
        },
        {
            type: "printed",
            label: "Printed"
        },
    ]

    /**
     * Return status label
     */
    const returnStatusLabel = (type: string) => {

        let label: string = ""

        statusList.map((status) => {
            if (status.type === type){
                label = status.label
            }
        })

        return label

    }

    const label: string = returnStatusLabel(type)

    return <span className={`status-chip ${type}`}>{customLabel ? customLabel : label}</span>
}